import { QueryClient, useQuery } from "@tanstack/react-query";

export const USER_SETTINGS_QUERY_KEY = "user-settings-list-query";

export interface UserSettingsDto {
  mother_tongue: "GERMAN" | "ENGLISH";
  show_experimental_features: boolean;
  show_welcome_card: boolean;
  show_experimental_speech_player: boolean;
  ai_model: "gpt-4o" | "gpt-4o-mini";
  weather_city: string;
  weather_country_code: string;
}

export function useUserSettings(opts?: { enabled: boolean }) {
  const userSettingsQuery = useQuery({
    queryKey: [USER_SETTINGS_QUERY_KEY],
    queryFn: async ({ signal }) => {
      const res = await fetch("/api/reeprise/user_settings/", { signal });
      if (!res.ok) {
        throw new Error("could not fetch user settings");
      }
      return (await res.json()) as UserSettingsDto;
    },
    enabled: opts?.enabled,
  });

  return userSettingsQuery;
}

export function invalidateQuery(client: QueryClient): void {
  client.invalidateQueries({ queryKey: [USER_SETTINGS_QUERY_KEY] });
}
